<div class="field">
  <div *ngIf="label" class="field__label">{{ label }}</div>
  <div class="field__text tw-flex">
    <ui-date-with-profile-and-local-timezone
      [timestamp]="startDate?.timestamp"
      [localTimezoneData]="startDate?.localTimezoneData"
      [profileTimezoneData]="startDate?.profileTimezoneData"
    ></ui-date-with-profile-and-local-timezone>
    <span *ngIf="departureDeviation">&nbsp;({{ departureDeviation }})</span>
    <div class="divider-container">
      <div class="circle start"></div>
      <div class="dash-line"></div>
      <div class="circle end"></div>
    </div>
    <ui-date-with-profile-and-local-timezone
      [timestamp]="endDate?.timestamp"
      [localTimezoneData]="endDate?.localTimezoneData"
      [profileTimezoneData]="endDate?.profileTimezoneData"
    ></ui-date-with-profile-and-local-timezone>
    <span *ngIf="arrivalDeviation">&nbsp;({{ arrivalDeviation }})</span>
    <ui-svg-icon
      *ngIf="showWarningIcon && (!startDate || !endDate)"
      [name]="iconNameList.AlertWarning"
      [width]="16"
      [matTooltip]="warningMessage"
      matTooltipPosition="above"
      class="field__warning"
    >
    </ui-svg-icon>
  </div>
</div>
